import slugify from './slugify';


const isItemActive = (location, item) => {
  // if (location.hash) {
  //   if (item.href) {
  //     return location.hash === toAnchor(item.href);
  //   }
  // } else if (item.id.includes('html')) {
  //   return location.pathname.includes(item.id);
  // }
  const slugId = location.pathname.split('/').slice(-1)[0];
  return slugId === slugify(item.id);
};

export default isItemActive;
